

<div class="page-title-area upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'About_Us' | translate }}</h2>
            <!--<a routerLink="/"> {{'Home' | translate }}</a>-->
        </div>
    </div>
</div>


<!-- Start About Area -->
<section class="about-area m-0 ">
    <div class="container">

        <div class="row align-items-center p-2">
            <div class="col-lg-12 col-md-12">
                <!-- data-aos="fade-right"-->
                <div class="about-content">
                    <div [innerHtml]="PageContentHTML"></div>
                </div>
            </div>
            <!--<div class="col-lg-6 col-md-12">-->
                <!-- data-aos="zoom-in"-->
                <!--<div class="about-image">
                    <img src="../../../../assets/img/about/about_us2.jpg" alt="image">
                </div>
            </div>-->
        </div>
    </div>
</section>
<!-- End About Area -->
